<template>
    <div class="arrow">
        <line-svg :color="color" :width="width" ></line-svg>
        <font-awesome-icon :icon="rightIcon" />
    </div>
</template>

<script>
    import LineSvg from './LineSvg'
    import { faChevronRight }  from '@fortawesome/pro-light-svg-icons/faChevronRight'

    export default {
        name: "Arrow",
        components: {
            LineSvg
        },
        props: {
            color: {
                type: String,
                default: 'white-stroke'
            },
            width: {
                type: Number,
                default: 27
            }
        },
        computed: {
            rightIcon() {
                return faChevronRight
            }
        }
    }
</script>

<style lang="scss" scoped>
    .arrow {
        display: flex;
        align-items: center;
    }
</style>